<template lang="pug">
.v-page-header.page-header
	.page-header__page-header
		.page-header__container.container
			header.page-header__wrap
				a.page-header__slot-logo()
					.page-header__logo
						a.page-header__logo-overlay(href="/" aria-label="Главная")
						object.page-header__logo-image(
							type="image/svg+xml"
							:data="currentLogoLink"
							ref="sevRef"
							width="100%"
						)
				.page-header__btn-hamburger-wrap(v-if="$slots['main-nav'] || $slots['contact']")
					button.page-header__btn-hamburger(type="button"
							:class="{'active': isHamburgerMenuOpen}"
							aria-label="Меню"
							@click="toggleMobileNav")
						.page-header__btn-hamburger-line.page-header__btn-hamburger-line--top
						.page-header__btn-hamburger-line.page-header__btn-hamburger-line--middle
						.page-header__btn-hamburger-line.page-header__btn-hamburger-line--bottom
					.page-header__menu.scrollbar-none
						.page-header__main-nav-slot(v-if="$slots['main-nav']")
							slot(name="main-nav")
						.page-header__contact-slot(v-if="$slots['contact']")
							slot(name="contact")
</template>

<script>
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';
import scrollLock from 'scroll-lock';
//import {mapGetters} from 'vuex';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		view: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			isHamburgerMenuOpen: false,
			isCatalogMenuOpen: false,
			isMobMenuHidden: false,
			userImageEmpty: "/local/assets/images/dealer-icon.png",
			//mainPageLink: "/"
			mainPageLink: "/local/assets/dist/markup/",
			svg: null,
			player: null,
			isAtTop: true,
			currentLogoLink: "",
			logoId: "",
			isHeaderScrolled: false
		};
	},

	created() {
		controller.events.on('mobile-nav-open', this.open);
		controller.events.on('mobile-nav-close', this.close);
		controller.events.on('mob-menu-hide', this.hideMobMenu);
		controller.events.on('mob-menu-show', this.showMobMenu);
	},

	computed() {
		// ...mapGetters({
		// 	isAuth: 'user/isAuthUser',
		// 	userImage: 'user/image',
		// 	userNotifyCount: 'user/userNotifyCount',
		// 	userName: 'user/userName',
		// }),
	},

	mounted() {
		// let $pageHeaderSpacer = document.createElement('div');
		// let className = 'page-header-spacer';
		// if (this.$slots['main-nav']) {
		// 	className += ' page-header-spacer--has-main-nav';
		// }
		// $pageHeaderSpacer.className = className;
		// document.body.prepend($pageHeaderSpacer);
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);

		setTimeout(() => {
			this.playerSvg()
			this.svg.svgatorPlayer.pause()
		}, 1000)

		const isRuRegion = document.querySelector('.region-ru')

		// if (isRuRegion)	{
			this.currentLogoLink = `/local/assets/source/icons/sprite/${isRuRegion ? 'KREOL_api' : 'logo_KREOLAK_dev'}.svg`
		// }
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		hideMobMenu() {
			this.isMobMenuHidden = true;
		},

		showMobMenu() {
			this.isMobMenuHidden = false;
		},

		lockScrolling() {
			const $fillGapElement = document.querySelector('.page-header');
			if ($fillGapElement) {
				scrollLock.addFillGapTarget($fillGapElement);
			}
			scrollLock.disablePageScroll(document.querySelectorAll('.page-header__menu'));
		},

		unlockScrolling() {
			scrollLock.enablePageScroll(document.querySelectorAll('.page-header__menu'));
		},

		playerSvg(targetTime, duration = 500) {

			// console.log('playerSvg', this.$refs['sevRef'], this.$refs['sevRef'].contentDocument.querySelector('svg'));
			this.logoId = this.$refs['sevRef'].contentDocument.querySelector('svg').getAttribute('id');
			this.svg = this.$refs['sevRef'].contentDocument.getElementById(this.logoId);
			this.svg.svgatorPlayer.set('speed', 1)
			this.player = this.svg && this.svg.svgatorPlayer;
		},

		open() {
			this.lockScrolling();
			this.isHamburgerMenuOpen = true;
			document.body.classList.add('state--mobile-nav-open');
		},

		close() {
			this.isHamburgerMenuOpen = false;
			document.body.classList.remove('state--mobile-nav-open');
			this.unlockScrolling();
		},

		closeMobileNav() {
			controller.closeMobileNav();
		},

		openMobileNav() {
			controller.openMobileNav();
		},

		toggleMobileNav() {
			if (this.isHamburgerMenuOpen) {
				this.closeMobileNav();
			} else {
				this.openMobileNav();
			}
		},

		playSvgAnimation(forward = true) {
			if (!this.player) return;

			const targetDirection = forward ? 1 : -1;

			if (this.player.direction !== targetDirection) {
				this.player.reverse();
				return;
			}

			if (forward) {
				const checkLimit = () => {
					if (this.player.currentTime >= 700) {
						this.player.pause();
						this.player.seek(700);
					} else if (this.player.playbackState === 'playing') {
						requestAnimationFrame(checkLimit);
					}
				};
				requestAnimationFrame(checkLimit);
			}

			this.player.play();
		},

		handleScroll() {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const windowHeight = window.innerHeight;
			const fullHeight = document.documentElement.scrollHeight;

			const threshold = 20;

			const isScrolledDown = scrollTop > threshold;
			const isAtBottom = scrollTop + windowHeight >= fullHeight - threshold;

			const isMobile = window.innerWidth < 768;

			const shouldScrollHeader = isMobile
				? isScrolledDown
				: isScrolledDown && !isAtBottom;

			this.isAtTop = !isScrolledDown;

			if (this.isHeaderScrolled === shouldScrollHeader) return;

			this.isHeaderScrolled = shouldScrollHeader;

			if (shouldScrollHeader) {
				document.body.classList.add('state--page-heder-scrolled');
				this.playSvgAnimation(true);
			} else {
				if ((isAtBottom && !isMobile) || this.isAtTop) {
					this.playSvgAnimation(false);
				}

				if (this.isAtTop) {
					document.body.classList.remove('state--page-heder-scrolled');
				}
			}
		},
	}
};
</script>
